import { logger } from '@/plugins/logger';
import { TextBuilder } from '@/utils/helpers/text-builder';

export const GA_EVENT_NAME = 'GAevent';

export const getGtmEventData = ({
  event = GA_EVENT_NAME,
  eventAction,
  eventCategory,
  eventLabel,
  params = {},
} = {}) => {
  const gtmParams = event === GA_EVENT_NAME
    ? { eventAction, eventCategory, eventLabel }
    : {};

  if (params?.userParams?.userAuthType) {
    return {
      event,
      userParams: params.userParams,
    };
  }

  return {
    event,
    ...gtmParams,
    ...params,
  };
};

const debugGtmEvent = (data = {}) => {
  const {
    event, eventAction, eventCategory, eventLabel, ...params
  } = data;

  if (window.dataLayerDebug) {
    window.dataLayerDebug.push(data);
  } else {
    window.dataLayerDebug = [data];
  }

  const textBuilder = new TextBuilder('%c')
    .addLine(event ? `${event}:` : '')
    .addLine(`eventAction: ${eventAction}`, eventAction !== undefined)
    .addLine(`eventCategory: ${eventCategory}`, eventCategory !== undefined)
    .addLine(`eventLabel: ${eventLabel}`, eventLabel !== undefined)
    .addLine(params.userParams ? `userParams: ${JSON.stringify(params.userParams)}` : `params: ${JSON.stringify(params)}`);

  logger.info(textBuilder.toString(), 'background: #FFD73B; color: #000');

  return Promise.resolve();
};

export const gtmEvent = (data) => {
  if (typeof window === 'undefined') return;

  const gtmEventData = getGtmEventData(data);

  if (process.env.NODE_ENV === 'development') return debugGtmEvent(gtmEventData);

  return new Promise(((resolve) => {
    window.dataLayer = window.dataLayer || [];

    window?.dataLayer?.push({
      ...gtmEventData,
      eventCallback: (id, result) => {
        if (!id || !result) return resolve(); // если блокируется аналитика, то резолвим сразу
        if (result?.tags?.length) return resolve(); // резолвим, если пришел ответ
      },
    });

    // резолвим через 2 сек, если событие долго идет или блокируется аналитика в браузере,
    setTimeout(resolve, 2000);
  }));
};
